import { Fraction } from 'fractional';

export const formatAspectRatio = (width: number, height: number): string => {
    const fraction = new Fraction(width, height);
    return `${fraction.numerator}:${fraction.denominator}`;
};
